import { Navigate, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfile } from "reducer/profileSlice";
import { useEffect, useState } from "react";

const ProtectedRoute = ({ component }) => {
  // const { userProfile } = useSelector((state) => state.userProfile);  //undefnied
  const [userType, setUserType] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getProfile = async () => {
    const res = await dispatch(getUserProfile());
    setUserType(res?.payload?.userType);
    if (res?.payload?.userType) {
      navigate("/feed");
    } else {
      navigate("/signup?profilePending=true");
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  return component;
};

export default ProtectedRoute;
